import request from "@/utils/request";
import {getTenant} from "@/utils/auth";

export function getPersonalInfo() {
  return request.get('/base/personalCenter/getAccountInfo')
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getQrCodeUrl(username) {
  const tenantCode = getTenant();
  return request.get(`/base/wx/getQrCodePictureExtendsUrl?username=${username}&tenantCode=${tenantCode}`)
    .then(res => res.data);
}

export function unbindWx(params) {
  return request.post(`/base/wx/wxUserUnbuckling`, params);
}

export function getOrdersFlow() {
  return request.get('/base/personalCenter/getOrderPayFlow')
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getPackageQuota() {
  return request.get('/base/personalCenter/getPackageQuota')
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function editEmail(email) {
  return request.post(`/base/personalCenter/user/updateEmail?email=${email}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function editRealName(name) {
  return request.post(`/base/personalCenter/user/updateName?name=${name}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function editPhone(phone, code, telCode) {
  return request.post(`/base/personalCenter/user/updatePhone?phone=${phone}&verificationCode=${code}&telephoneCode=${telCode}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function editPassword(pwd, confirmPwd) {
  return request.post(`/base/personalCenter/user/updatePwd`, {pwd, confirmPwd})
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function checkOldPhoneCaptcha(code, mobile) {
  return request.get(`/oauth/anno/checkOldPhoneCaptcha?mobile=${mobile}&code=${code}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function updateOldPhoneCaptcha(data) {
  return request({
    url: '/oauth/anno/updateOldPhoneCaptcha',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

export function updateNewPhoneCaptcha(data, telephoneCode) {
  return request({
    url: `/oauth/anno/updateNewPhoneCaptcha?telephoneCode=${telephoneCode}`,
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

// 新增修改删除用户公司信息
export function userSaveOrUpdate(params) {
  return request.post(`/authority/user/saveOrUpdate`, params)
  .then((res) => {
      return Promise.resolve(res.data)
  })
}

// 获取公司列表
export function userCompanyInfo(params) {
  return request.get(`/authority/user/userCompanyInfo`, params)
  .then((res) => {
      return Promise.resolve(res)
  })
}